<template>
  <div class="article-info-date__text text-medium">
    {{ publishedDate }}
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { propValidator, PROP_TYPES } from '@fmpedia/validators'
export default {
  name: 'AArticleInfoDate',
  props: {
    publishedOn: propValidator([PROP_TYPES.STRING])
  },
  methods: {
    isOlderThanOneDay() {
      const givenDate = DateTime.fromISO(this.publishedOn)
      const oneDayAgo = DateTime.local().minus({ days: 1 })

      return givenDate < oneDayAgo
    }
  },
  computed: {
    publishedDate() {
      return this.isOlderThanOneDay()
        ? this.$helper.formatDate.toDateAndHours(this.publishedOn)
        : this.$helper.formatDate.toIntervalFromNow(this.publishedOn)
    }
  }
}
</script>

<style lang="scss">
.article-info-date__text {
  color: $c--gray-dark;
}
</style>
